import React from "react";
import PermissionDenied from "./PermissionDenied";
import { hasPermission, IPermission } from "./PermissionManger";

interface RequirePermissionProps {
  page: string;
  action?: keyof IPermission;
  children: React.ReactElement;
}

/** Route guard: renders the page only if the user's role allows `action` on `page`. */
export const RequirePermission: React.FC<RequirePermissionProps> = ({ page, action = "view", children }) =>
  hasPermission(page, action) ? children : <PermissionDenied />;
